import { render, staticRenderFns } from "./About.vue?vue&type=template&id=1abc7b27&scoped=true"
import script from "./about.js?vue&type=script&lang=js&external"
export * from "./about.js?vue&type=script&lang=js&external"
import style0 from "./about.scss?vue&type=style&index=0&id=1abc7b27&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1abc7b27",
  null
  
)

export default component.exports